import { getWujiCompInstance } from '@/utils/comps-loader';
export const presets = [
    'vue',
    'lodash',
    'axios',
    'dayjs',
    'ant-design-vue',
    'tdesign-vue-next',
    '@wujibase/wuji',
    '@wujibase/wuji-workflow',
    '@wujibase/wuji-upload',
];
class PresetLoader {
    presetHandlers = new Map();
    registerPreset(presetNames, handler) {
        presetNames.forEach((presetName) => {
            this.presetHandlers.set(presetName, handler);
        });
    }
    async load(presets) {
        const uniqueHandlers = new Set();
        presets.forEach((preset) => {
            const handler = this.presetHandlers.get(preset);
            if (handler) {
                uniqueHandlers.add(handler);
            }
        });
        const loadingTasks = Array.from(uniqueHandlers).map(async (handler) => {
            try {
                await handler();
            }
            catch (error) {
                throw error;
            }
        });
        await Promise.all(loadingTasks);
    }
}
const presetLoader = new PresetLoader();
presetLoader.registerPreset(['vue', 'ant-design-vue', 'tdesign-vue-next'], async () => {
    const wujiComp = getWujiCompInstance();
    const { moduleManage } = wujiComp;
    if (!moduleManage.webpackExternals?.includes('vue3')) {
        return moduleManage.loadVue3Dependencies();
    }
});
presetLoader.registerPreset(['react', 'antd', 'react-dom'], async () => {
    const wujiComp = getWujiCompInstance();
    const { moduleManage } = wujiComp;
    if (!moduleManage.webpackExternals?.includes('React')) {
        return moduleManage.loadReactDependencies();
    }
});
export default presetLoader;
